import React from 'react';
import styles from './AltNavbar.module.css';
import logo from '../../assets/logo.webp';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

const AltNavbar = () => {
  return (
    <nav className={styles.navbar}>
      <Link to="/">
        <img className={styles.logo} src={logo} alt="synergy youth logo" />
      </Link>
      <Link to="/">
        <FaHome />
        返回首頁
      </Link>
    </nav>
  );
};

export default AltNavbar;
